import { getTableName } from 'helpers/helpers';
import { useMemo } from 'react';
import {
    getDataInTreeFormat,
    getTreeDataDomains,
    TreeData,
} from 'routes/Explore/components/Sentence/helpers/treeData';
import { useSentenceContext } from '../../Contexts/SentenceContext/SentenceContext';

export const useGetDataInTreeFormat = (
    options: AvailableElementT[],
    categories: { [key: string]: { [key: string]: string[] } },
): TreeData =>
    useMemo(
        () => getDataInTreeFormat(options, categories),
        [
            // NOTE: this useMemo key can create performances issues,
            // to replace by options.length if too much
            JSON.stringify(options.map((o) => o.field)),
            categories,
        ],
    );

export const useGetDefaultTableToExpand = (treeData: TreeData) => {
    const {
        sentence: { metrics },
    } = useSentenceContext();
    const tableToExpand = new Set(
        metrics
            .map((metric) => {
                if (!metric.field) {
                    return [];
                }
                const domains = getTreeDataDomains(metric, treeData);
                return domains.flatMap((func) => [
                    func,
                    `${func}-table-${getTableName(metric.field)}`,
                ]);
            })
            .flat(),
    );
    return Array.from(tableToExpand);
};
